import api from "./axios";

export const createCurrency = async (payload) => {
  const response = await api.post("/currency", payload);
  return response.data;
};

export const getCurrencies = async (params = {}) => {
  const response = await api.get("/currency", { params });
  return response.data;
};

export const getCurrencyById = (id) => {
  return api.get(`/currency/${id}`);
};

export const updateCurrency = async (id, payload) => {
  const response = await api.put(`/currency/${id}`, payload);
  return response.data;
};

export const deleteCurrency = (id, payload) => {
  return api.delete(`/currency/${id}`, { data: payload });
};

export const getCurrencyDropdown = async() => {
  const response = await api.get(`/currency/dropdown`);
  return response.data;
};